import { uiText, useUiLanguage } from '@/i18n/interface';
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@/components/ui/card';
import { Users, Calendar, Award, User } from 'lucide-react';

interface Props { stats: { totalStudents: string; activeSessions: string; pendingResponses: string; advancedStudents: string }; isLoading: boolean; }
export default function AdminStats({ stats, isLoading }: Props) {
  useUiLanguage();
  const { t } = useTranslation('common');
  const items = [
    ['admin.stats.totalStudents', uiText("Students"), stats.totalStudents, Users],
    ['admin.stats.activeSessions', uiText("Upcoming sessions"), stats.activeSessions, Calendar],
    ['admin.stats.pendingResponses', uiText("Upcoming promotions"), stats.pendingResponses, Award],
    ['admin.stats.advancedStudents', uiText("Advanced students"), stats.advancedStudents, User],
  ] as const;
  return <div className="grid grid-cols-2 gap-3 xl:grid-cols-4" aria-busy={isLoading}>
    {items.map(([key, fallback, value, Icon]) => <Card key={key}><CardContent className="flex items-start justify-between gap-2 p-4 sm:p-5 sm:pt-5">
      <div><p className="text-xs text-muted-foreground">{t(key, { defaultValue: fallback })}</p><p className="wh-stat-value mt-3">{isLoading ? '—' : value}</p></div><span className="wh-icon-tile"><Icon className="h-4 w-4" /></span>
    </CardContent></Card>)}
  </div>;
}
